<template>
  <div class="billManagement">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/jianguanInventoryOrder' }">返回</el-breadcrumb-item>
      <el-breadcrumb-item>货物</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 查询条件 -->
    <div ref="searchBox" class="inpBox">
      <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData">
        <el-form-item label="捆包号:">
          <el-input type="textarea" v-model="cargoBarcodes" style="width:175px;" size="mini" placeholder="可支持多个"></el-input>
        </el-form-item>
        <el-form-item label="盘库状态:">
          <el-select v-model="formData.inventoryDetailStatus" size="mini" placeholder="请选择盘库状态" filterable clearable>
            <el-option v-for="item in inventoryDetailStatusData" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="盘库时间:">
          <el-date-picker v-model="formData.inventoryTimeStart" size="mini" type="datetime" placeholder="请选择盘库时间" value-format="yyyy-MM-dd HH:mm:ss" style="width: 175px"></el-date-picker>-
          <el-date-picker v-model="formData.inventoryTimeEnd" size="mini" placeholder="请选择盘库时间" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 175px"></el-date-picker>
        </el-form-item>
        <br />
        <el-form-item>
          <el-button type="primary" size="mini" @click="chaxun" v-if="btnFlg[9]">查询</el-button>
          <el-button type="primary" size="mini" @click="chongzhi" v-if="btnFlg[10]">重置</el-button>
          <el-button type="primary" size="mini" @click="firstInstancePassed" v-if="btnFlg[11]">一审通过
          </el-button>
          <el-button type="primary" size="mini" @click="firstInstanceRejected" v-if="btnFlg[12]">一审驳回</el-button>
          <el-button type="primary" size="mini" @click="secondInstancePassed" v-if="btnFlg[13]">二审通过</el-button>
          <el-button type="primary" size="mini" @click="secondInstanceRejected" v-if="btnFlg[14]">二审驳回</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div :style="{ height: h }">
      <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData" style="width: 100%" class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row @selection-change="selectionChange">
        <el-table-column type="selection" align="center"></el-table-column>
        <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template v-slot="scope">
            <el-button type="text" @click="tupian(scope.row)">图片</el-button>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号" align="center" width="250"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productName" label="品名" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量(吨)" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="contractNumber" label="合同号" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="agreementNumber" label="合约号" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="货位" align="center" width="150">
          <template v-slot="scope">
            <div>{{scope.row.warehouseName + scope.row.locationName + scope.row.binName}}</div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="inventoryDetailStatus" label="盘库状态" align="center" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.inventoryDetailStatus==0">未盘</span>
            <span v-else-if="scope.row.inventoryDetailStatus==1">已盘</span>
            <span v-else-if="scope.row.inventoryDetailStatus==2">盘库新增</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="inventoryPerson" label="盘库人" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="inventoryTime" label="盘库时间" align="center" width="180"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="firstInstanceStatus" label="一审状态" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="firstInstancePerson" label="一审人" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="firstInstanceTime" label="一审时间" align="center" width="180"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="secondInstanceStatus" label="二审状态" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="secondInstancePerson" label="二审人" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="secondInstanceTime" label="二审时间" align="center" width="180"></el-table-column>
      </el-table>
    </div>
    <div class="pags" style="text-align: right">
      <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo" :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
    </div>
    <div class="addMarkBox">
      <el-dialog title="查看图片" :close-on-click-modal="false" :visible.sync="addMarkLookBox" width="60%" center>
        <div v-if="imgData.length == 0" class="noImg">暂无图片</div>
        <div>
          <div class="img_box" v-for="(item,index) in imgData" :key="index">
            <el-image :src="item.url" :preview-src-list="imgList" class="tupian"></el-image>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  zidianKuwei, // 字典库位
  zidianQuwei, // 字典区位
  zidianHuowei, // 字典货位
  getJGInventoryGoodsList,
  getImgShow,
  jGExamine
} from '@/api/wms-stock'
import { getBtn } from '@/utils/getButton'
export default {
  data () {
    return {
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      tableData: [],
      formData: {
        cargoBarcodes: '',
        inventoryDetailStatus: '',
        inventoryTimeStart: '',
        inventoryTimeEnd: ''
      },
      cargoBarcodes: '',
      addKuwei: [],
      addQ: [],
      addH: [],
      cangKuName: '', // 仓库名
      quWeiName: '', // 区位名
      huoWeiName: '', // 货位名
      kuweiId: '', // 库位id
      kuweiName: '', // 库位name
      QId: '', // 区位id
      QName: '', // 区位name
      HId: '', // 货位id
      HName: '', // 货位name
      inventoryDetailStatusData: [
        {
          id: '1',
          name: '已盘'
        },
        {
          id: '0',
          name: '未盘'
        }
      ],
      total: 0,
      addMarkLookBox: false,
      imgData: [],
      inventoryMasterId: '',
      imgList: [],
      h: '500px',
      btnArr: [
        '0130070100',
        '0130070200',
        '0130070300',
        '0130070400',
        '0130070500',
        '0130070600',
        '0130070700',
        '0130070800',
        '0130070900',
        '0130070F00',
        '0130070G00',
        '0130070B00',
        '0130070C00',
        '0130070D00',
        '0130070E00'
      ],
      btnFlg: [],
      selection: []
    }
  },
  created () {
    this.chaxun()
  },
  mounted () {
    this.btnFlg = getBtn(this.btnArr, '/jianguanInventoryOrder')
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 220 + 'px'
  },
  methods: {
    // 拆开写，为了防止之后需要添加审核理由
    firstInstancePassed () {
      if (this.selection.length == 0) {
        this.$message.error('请选择至少一条数据')
        return
      }
      if (this.$route.query.finished == 1) {
        this.$message.error('盘库单已结束，不可审核')
        return
      }
      const someweipan = this.selection.some(item => item.inventoryDetailStatus != 1)
      if (someweipan) {
        this.$message.error('存在未盘状态货物，不可审核！')
        return
      }
      const someReject = this.selection.some(item => item.firstInstanceStatus != '待审核')
      if (someReject) {
        this.$message.error('存在已审核数据，不可通过！')
        return
      }
      this.$confirm('是否确定一审通过', '提示', { confirmButtonText: '确定', cancelButtonText: '取消' })
        .then(res => {
          jGExamine({
            // inventoryMasterId: this.$route.query.inventoryMasterId,
            inventoryDetailIds: this.selection.map(item => item.inventoryDetailId).join(','),
            firstInstanceStatus: '2'
          }).then(res => {
            console.log(res)
            this.$message.success('成功')
            this.chaxun()
          })
            .catch(error => {
              this.$message.error(error.message)
            })
        })
    },
    firstInstanceRejected () {
      if (this.selection.length == 0) {
        this.$message.error('请选择至少一条数据')
        return
      }
      if (this.$route.query.finished == 1) {
        this.$message.error('盘库单已结束，不可审核')
        return
      }
      const someweipan = this.selection.some(item => item.inventoryDetailStatus != 1)
      if (someweipan) {
        this.$message.error('存在未盘状态货物，不可审核！')
        return
      }
      const someReject = this.selection.some(item => item.firstInstanceStatus != '待审核')
      if (someReject) {
        this.$message.error('存在已审核数据，不可驳回！')
        return
      }
      this.$confirm('是否确定一审驳回', '提示', { confirmButtonText: '确定', cancelButtonText: '取消' })
        .then(res => {
          jGExamine({
            // inventoryMasterId: this.$route.query.inventoryMasterId,
            inventoryDetailIds: this.selection.map(item => item.inventoryDetailId).join(','),
            firstInstanceStatus: '3'
          }).then(res => {
            this.$message.success('成功')
            console.log(res)
            this.chaxun()
          })
            .catch(error => {
              this.$message.error(error.message)
            })
        })
    },
    secondInstancePassed () {
      if (this.selection.length == 0) {
        this.$message.error('请选择至少一条数据')
        return
      }
      if (this.$route.query.finished == 1) {
        this.$message.error('盘库单已结束，不可审核')
        return
      }
      const someweipan = this.selection.some(item => item.inventoryDetailStatus != 1)
      if (someweipan) {
        this.$message.error('存在未盘状态货物，不可审核！')
        return
      }
      const firstReject = this.selection.some(item => item.firstInstanceStatus == '待审核')
      if (firstReject) {
        this.$message.error('一审未开始不可二审')
        return
      }
      const firstBohui = this.selection.some(item => item.firstInstanceStatus == '驳回')
      if (firstBohui) {
        this.$message.error('存在一审驳回数据，不可二审')
        return
      }
      const someReject = this.selection.some(item => item.secondInstanceStatus != '待审核')
      if (someReject) {
        this.$message.error('存在已审核数据，不可通过！')
        return
      }

      this.$confirm('是否确定二审通过', '提示', { confirmButtonText: '确定', cancelButtonText: '取消' })
        .then(res => {
          jGExamine({
            // inventoryMasterId: this.$route.query.inventoryMasterId,
            inventoryDetailIds: this.selection.map(item => item.inventoryDetailId).join(','),
            secondInstanceStatus: '2'
          }).then(res => {
            this.$message.success('成功')
            this.chaxun()
          })
            .catch(error => {
              this.$message.error(error.message)
            })
        })
    },
    secondInstanceRejected () {
      if (this.selection.length == 0) {
        this.$message.error('请选择至少一条数据')
        return
      }
      if (this.$route.query.finished == 1) {
        this.$message.error('盘库单已结束，不可审核')
        return
      }
      const someweipan = this.selection.some(item => item.inventoryDetailStatus != 1)
      if (someweipan) {
        this.$message.error('存在未盘状态货物，不可审核！')
        return
      }
      const firstReject = this.selection.some(item => item.firstInstanceStatus == '待审核')
      if (firstReject) {
        this.$message.error('一审未开始不可二审')
        return
      }
      const firstBohui = this.selection.some(item => item.firstInstanceStatus == '驳回')
      if (firstBohui) {
        this.$message.error('存在一审驳回数据，不可二审')
        return
      }
      const someReject = this.selection.some(item => item.secondInstanceStatus != '待审核')
      if (someReject) {
        this.$message.error('存在已审核数据，不可驳回！')
        return
      }

      this.$confirm('是否确定二审驳回', '提示', { confirmButtonText: '确定', cancelButtonText: '取消' })
        .then(res => {
          jGExamine({
            // inventoryMasterId: this.$route.query.inventoryMasterId,
            inventoryDetailIds: this.selection.map(item => item.inventoryDetailId).join(','),
            secondInstanceStatus: '3'
          }).then(res => {
            this.$message.success('成功')
            this.chaxun()
          })
            .catch(error => {
              this.$message.error(error.message)
            })
        })
    },
    selectionChange (selection) {
      this.selection = selection
    },
    getJGInventoryGoodsList () {
      this.cargoBarcodes = this.cargoBarcodes.replace(/\n/g, ',')
      this.formData.cargoBarcodes = this.cargoBarcodes = this.cargoBarcodes.split(',').filter(item => item != '').join(',')
      getJGInventoryGoodsList({
        inventoryMasterId: this.$route.query.inventoryMasterId,
        ...this.formData,
        warehouseName: this.kuweiName,
        locationName: this.QName,
        binName: this.HName,
        ...this.pageInfo
      }).then(res => {
        console.log(res)
        this.tableData = res.list
        this.total = res.total
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    chaxun () {
      this.getJGInventoryGoodsList()
    },
    chongzhi () {
      this.formData = {
        cargoBarcodes: '',
        inventoryDetailStatus: '',
        inventoryTimeStart: '',
        inventoryTimeEnd: ''
      }
      this.cargoBarcodes = ''
      this.kuweiId = '' // 仓库名（下拉框key）
      this.QId = '' // 区位名（下拉框key）
      this.HId = '' // 货位名（下拉框key）
      this.cangKuName = '' // 仓库名
      this.quWeiName = '' // 区位名
      this.huoWeiName = ''
      this.kuweiName = ''
      this.QName = ''
      this.HName = ''
      this.chaxun()
    },
    tupian (row) {
      this.addMarkLookBox = true
      getImgShow({
        businessId: row.inventoryDetailId,
        businessType: 'inventory_picture'
      }).then(res => {
        console.log(res)
        this.imgData = res
        this.imgList = res.map(item => item.url)
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    // 字典--库位
    zidianKuweiS () {
      zidianKuwei({})
        .then((res) => {
          this.addKuwei = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 字典--区位
    zidianQuweiS () {
      zidianQuwei({
        warehouseId: this.kuweiIds || this.xuanzhongArr.warehouseId || this.kuweiId
      })
        .then((res) => {
          this.addQ = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 字典--货位
    zidianHuoweiS () {
      // console.log(this.QIds ,this.xuanzhongArr.locationId ,this.QId)
      zidianHuowei({
        locationid: this.QIds || this.xuanzhongArr.locationId || this.QId
      })
        .then((res) => {
          this.addH = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取库位下拉框其他值
    changeXiugaiKW: function (valueS) {
      let choosenKuwei = this.addKuwei.filter(
        (item) => item.warehouseId === valueS
      )[0]
      this.quWeiName = ''
      this.huoWeiName = ''
      this.QId = ''
      this.HId = ''
      this.kuweiId = choosenKuwei.warehouseId
      this.kuweiName = choosenKuwei.warehouseName
      // this.zidianQuweiS()
      zidianQuwei({
        warehouseId: this.kuweiId
      })
        .then((res) => {
          this.addQ = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取区位下拉框其他值
    changeXiugaiQW: function (valueS) {
      let choosenQ = this.addQ.filter((item) => item.locationId === valueS)[0]
      this.QId = choosenQ.locationId
      this.QName = choosenQ.locationName
      this.huoWeiName = ''
      this.HId = ''
      zidianHuowei({
        locationid: this.QId
      })
        .then((res) => {
          this.addH = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取货位下拉框其他值
    changeXiugaiHW: function (valueS) {
      let choosenH = this.addH.filter((item) => item.binId === valueS)[0]
      this.HId = choosenH.binId
      this.HName = choosenH.binName
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    }
  }
}
</script>

<style lang="less" scoped>
.inpBox {
  margin-top: 10px;
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
.addMarkBox {
  .noImg {
    text-align: center;
  }
}
.img_box {
  width: 150px;
  height: 200px;
  display: inline-block;
  margin-right: 20px;
  border: 1px dashed #ccc;
  padding: 5px;
  .tupian {
    width: 100%;
    height: 100%;
  }
}
</style>
